import { AccrualReviewActionKind } from "./accrualReviewBulkApprove";

/**
 * How many blue suggested cells a row Confirm writes: each accrual ledger
 * account plus the match. Classes and counterparty a match also updates are
 * not counted.
 */
export const getAccrualConfirmChangeCount = ({
    accrualLedgerCount,
    accountOverrideCount,
    hasFallbackAccount,
    hasActiveMatchSuggestion,
}: {
    accrualLedgerCount: number;
    accountOverrideCount: number;
    hasFallbackAccount: boolean;
    hasActiveMatchSuggestion: boolean;
}): number => {
    const fallbackLedgerChangeCount = hasFallbackAccount ? 1 : 0;
    const ledgerChangeCount =
        accrualLedgerCount > 0
            ? accountOverrideCount
            : fallbackLedgerChangeCount;
    return ledgerChangeCount + (hasActiveMatchSuggestion ? 1 : 0);
};

/**
 * How the row Confirm / Match button renders: `plain` keeps today's button,
 * `withChangeCount` badges it with the fields it writes.
 */
export type AccrualConfirmDisplayVariant = "plain" | "withChangeCount";

/**
 * Whether the row action is Confirm / Match rather than Review, and the badge
 * count it carries. With `withChangeCount`, a Confirm that writes nothing
 * falls back to Review.
 */
export const getAccrualConfirmDisplay = ({
    action,
    changeCount,
    confirmDisplay,
}: {
    action: AccrualReviewActionKind;
    changeCount: number;
    confirmDisplay: AccrualConfirmDisplayVariant;
}): { isConfirmShown: boolean; badgeCount: number | undefined } => {
    if (action !== AccrualReviewActionKind.ACCEPT) {
        return { isConfirmShown: false, badgeCount: undefined };
    }
    switch (confirmDisplay) {
        case "plain":
            return { isConfirmShown: true, badgeCount: undefined };
        case "withChangeCount":
            return { isConfirmShown: changeCount > 0, badgeCount: changeCount };
    }
};
